import { Box, Menu as MuiMenu } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const ITEM_HEIGHT = 42

export const ProductOptionsMenuContainer = styled(Box)`
  .menu-icon-button {
    &:hover {
      background: ${theme.colors.legacyAlpha8};
    }

    html[data-theme='light'] & {
      /* CSS fill beats the glyph's own presentation attribute, which can't take a var() */
      svg path {
        fill: ${theme.colors.devicesSecondaryText};
      }
    }
  }
`

export const Menu = styled(MuiMenu)`
  .MuiPaper-root {
    width: 244px;
    border-radius: 12px;
    background: ${theme.colors.menuBg};
    border: 1px solid ${theme.colors.menuItemHover};
    box-shadow: ${theme.colors.tooltipShadow};

    .MuiList-root {
      padding-top: 0;
      padding-bottom: 0;

      .MuiMenuItem-root {
        height: ${ITEM_HEIGHT}px;
        display: flex;
        align-items: center;
        gap: 8px;

        html[data-theme='light'] & {
          /* leading glyphs are stroked #D0C3CC attributes; the destructive ones stay red */
          svg path:not([stroke='#E74C3C']) {
            stroke: ${theme.colors.devicesSecondaryText};
          }
        }

        .MuiTypography-root {
          color: ${theme.colors.foreground};
          font-family: Quicksand, sans-serif;
          font-size: 14px;
          font-style: normal;
          font-weight: 500;
          line-height: 22px;
        }

        &:first-of-type {
          height: ${ITEM_HEIGHT + 6}px;
          padding-top: 6px;
        }

        &:last-of-type {
          height: ${ITEM_HEIGHT + 6}px;
          padding-bottom: 6px;
        }

        &:hover {
          background: ${theme.colors.menuItemHover};
          cursor: default;
        }

        &:nth-of-type(3) {
          border-bottom: 1px solid ${theme.colors.menuItemHover};
        }

        &:nth-of-type(4),
        &:nth-of-type(5) {
          .MuiTypography-root {
            color: #e74c3c;
          }
        }
      }
    }
  }
`
